import React from 'react'
import { IoPeopleSharp } from "react-icons/io5";
import { GoGraph } from "react-icons/go";
import { IoMdMail } from "react-icons/io";
import { FaArrowRight, FaBuffer } from "react-icons/fa";
// import ServiceBox from '../../components/homeComponent/ServiceBox';
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { Accordion } from 'react-bootstrap';
import Header from '../../components/header/Header';
import Factsboxes from './component/Factsboxes';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Footer from '../../components/footer/Footer';
import { CarouselData } from '../landing/datas';
import OwlCarousel from 'react-owl-carousel';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';


const About = () => {

    const location = useLocation();
    console.log("locationAbout", location?.pathname);

    return (
        <>
            <Helmet>
                <title>About iLine AI Logistics app| Leading Logistics app in Delhi</title>
                <meta name="description" content="Learn more about iLine Logistics, Delhi's top EV logistics app. Discover our mission, vision, and commitment to providing EV delivery services and comprehensive logistics solutions tailored to your needs." />
                <link rel="canonical" href={`https://iline.ai${location.pathname}`} />
            </Helmet>
            <Header />
            <section className='WhoWeAre'>
                <div className="container">
                    <div className="wwaLeft">
                        <h2>Who We Are</h2>
                    </div>
                    <div className="wwaRight">
                        <p>
                            Iline is a forward-thinking startup dedicated to transforming the logistics industry by leveraging electric vehicles (EVs) to minimize carbon footprints and enhance air quality. Through advanced, AI-driven technology, Iline streamlines scheduling and optimizes battery management to maximize vehicle efficiency and sustainability. By integrating intelligent systems, the company ensures seamless operations, reduces energy consumption, and passes on cost savings directly to its users. Iline Solutions is at the forefront of eco-friendly logistics, committed to creating cleaner, smarter, and more cost-effective delivery solutions that benefit businesses, communities, and the environment.
                        </p>
                    </div>
                </div>
            </section>

            {/* <figure><img src={require('../../assets/images/services/service-banner.webp')} /></figure> */}
            {/* <div className="container">
                <div className="row">
                    <ServiceBox />
                </div>
            </div> */}
            {/* <section className='OurStoryArea'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="osaLeft">
                                <h2>Our Story</h2>
                                <p>Providing an independent advice and identifying the right fit for you. Services are sourced and procured based on solution specifications provided by our Supply Chain Solution.</p>
                                <p>Services are sourced and procured based on solution specifications provided by our Supply Chain Solution.</p>
                                <div className="ServiceAccordion">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header> <span>1</span> Founder <MdOutlineKeyboardArrowDown /> </Accordion.Header>
                                            <Accordion.Body>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                                minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                                aliquip ex ea commodo consequat.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header> <span>2</span> How We Start <MdOutlineKeyboardArrowDown /> </Accordion.Header>
                                            <Accordion.Body>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                                minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                                aliquip ex ea commodo consequat.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header> <span>3</span> First Big Customer <MdOutlineKeyboardArrowDown /> </Accordion.Header>
                                            <Accordion.Body>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                                minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                                aliquip ex ea commodo consequat.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="osaRight">
                                <figure><img src={require('../../assets/images/about-us/about-1.jpg')} /></figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section className='WhyChoose'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="wcLeft">
                                <h2>Why Choose Us
                                </h2>
                                <p>Our unrivaled technology uses a unique approach for the analyzing, modeling, and predicting of transport flows with a very high accuracy.</p>
                                <p>This advantage comes from combining the technical knowledge of Big Data and Predictive Analytics with hands-on expertise in transport and logistics.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="wcRight">
                                <ol>
                                    <li> <span>1.</span> Software developed exclusively for logistics companies</li>
                                    <li> <span>2.</span> Highly professional team with deep cargo knowledge, as well as expertise in software development and data science</li>
                                    <li> <span>3.</span> Low-risk – Transmetrics offers Software-as-a-Service products on a monthly subscription</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section className='FactsFigures'>
                <div className="section-title" data-aos="fade-up">
                    <h2>Facts And Figures</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Malesuada ac augue <br /> ligula faucibus vulputate. Mattis a nibh mattis morbi nunc velit egestas neque, <br /> fringilla.</p>
                </div>
                <div className='FactLine'></div>
                <div className="container">
                    <div className='Outer'>
                        <div className='Inner'><span className='Circle'></span></div>
                        <div className='Inner'><span className='Circle'></span></div>
                        <div className='Inner'><span className='Circle'></span></div>
                        <div className='Inner'><span className='Circle'></span></div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="FactBox">
                                <h3 data-aos="fade-up" data-aos-delay="200">95%</h3>
                                <p data-aos="fade-up" data-aos-delay="200">Forecasting accuracy</p>
                                <span className='Circle' data-aos="fade-up" data-aos-delay="200"></span>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="FactBox">
                                <h3 data-aos="fade-up" data-aos-delay="300">20%</h3>
                                <p data-aos="fade-up" data-aos-delay="300">Savings on network operation costs</p>
                                <span className='Circle' data-aos="fade-up" data-aos-delay="300"></span>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="FactBox" data-aos="fade-up" data-aos-delay="400">
                                <h3>10%</h3>
                                <p>Reduction in total transportation costs</p>
                                <span className='Circle'></span>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="FactBox" data-aos="fade-up" data-aos-delay="500">
                                <h3>12%</h3>
                                <p>Reduction in employed asset fleet</p>
                                <span className='Circle'></span>
                            </div>
                        </div>
                    </div>

                </div>
            </section> */}

            {/* <section className='FourBoxArea'>
                <div className="container">
                    <div className="row">
                        <Factsboxes />
                    </div>
                </div>
            </section> */}

            {/* <section className='WhatOurClientsSay'>
                <div className="container">
                    <div className="AboutTabs">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <div className="row">
                                <div className="col-lg-4">
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">
                                                <aside>
                                                    <figure><img src={require('../../assets/images/landing-images/Avatar-1.png')} /></figure>
                                                    <figcaption>
                                                        <h5>Leo Benderson Linchin</h5>
                                                        <p>CEO, GEOBOOST LTD</p>
                                                    </figcaption>
                                                </aside>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">
                                                <aside>
                                                    <figure><img src={require('../../assets/images/landing-images/Avatar-1.png')} /></figure>
                                                    <figcaption>
                                                        <h5>Leo Benderson Linchin</h5>
                                                        <p>CEO, GEOBOOST LTD</p>
                                                    </figcaption>
                                                </aside>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third">
                                                <aside>
                                                    <figure><img src={require('../../assets/images/landing-images/Avatar-1.png')} /></figure>
                                                    <figcaption>
                                                        <h5>Leo Benderson Linchin</h5>
                                                        <p>CEO, GEOBOOST LTD</p>
                                                    </figcaption>
                                                </aside>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <div className="col-lg-8">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <div className="tab-body">
                                                <img src={require('../../assets/images/about-us/img-1.svg').default} />
                                                <p>My shipment was picked up and delivered with excellent service! Needless to say I am extremely satisfied with the results. Will definitely use this service again.
                                                <img src={require('../../assets/images/about-us/img-1.svg').default} />
                                                </p>
                                                
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <div className="tab-body">
                                                <img src={require('../../assets/images/about-us/img-1.svg').default} />
                                                <p>“The fantastic team at Logi 128 freight have helped us out no end. I have saddled them with some impossible tasks and they have worked nice at anything we have thrown at them.”
                                                <img src={require('../../assets/images/about-us/img-1.svg').default} />
                                                </p>
                                                
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="third">
                                            <div className="tab-body">
                                                <img src={require('../../assets/images/about-us/img-1.svg').default} />
                                                <p>Operations deal with the way the vehicles are operated, and the procedures set for this purpose, and policies.
                                                <img src={require('../../assets/images/about-us/img-1.svg').default} />

                                                </p>
                                                
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
            </section> */}


            {/* 
            <section className='base-container mt-5'>
                <div className="container">
                    <div className="service-info">
                        <div class="info-wrap">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="300">
                                <a href="#" class="icon-text">
                                    <IoPeopleSharp />
                                </a>

                                <h3>Unbeatable Savings with EV Shipping</h3>
                                <p class="paragraph">
                                    <strong>Lower Costs:</strong> Say goodbye to high fuel expenses and excessive maintenance charges. Our EV logistics model ensures cost-effective deliveries for your business.
                                </p>
                                <p class="paragraph">
                                    <strong>Affordable Rates:</strong> We offer competitive pricing without sacrificing quality, helping you maximize your budget.
                                </p>
                            </div>
                            <div class="info-card" data-aos="fade-up" data-aos-delay="400">
                                <a href="#" class="icon-text">
                                    <GoGraph />
                                </a>
                                <h3>Eco-Friendly Transportation</h3>
                                <p class="paragraph">
                                    <strong>Zero Emissions:</strong> By choosing I-Line, you contribute to a greener planet by eliminating CO₂ and harmful gas emissions with every delivery.
                                </p>
                                <p class="paragraph">
                                    <strong>Real-Time Carbon Tracking:</strong> Monitor and showcase the positive environmental impact of your shipments to align with sustainability goals.
                                </p>
                            </div>
                            <div class="info-card" data-aos="fade-up" data-aos-delay="500">
                                <a href="#" class="icon-text">
                                    <IoMdMail />
                                </a>
                                <h3>Efficiency Meets Innovation</h3>
                                <p class="paragraph">
                                    <strong>Advanced AI Technology:</strong> Depend on precision and punctuality with our state-of-the-art electric fleet.
                                </p>
                                <p class="paragraph">
                                    <strong>Smart Routing:</strong> Experience faster, more energy-efficient deliveries with optimized routing, reducing delays and costs.
                                </p>
                            </div> */}

            {/* <div class="info-card">
                                <a href="#" class="icon-text">
                                    <FaBuffer />
                                </a>
                                <h3>Quality</h3>
                                <p class="paragraph-large dark-gray">
                                    We are committed to deliver outstanding, cutting edge IT
                                    solutions that add real value that goes beyond what is
                                    expected.
                                    <br />
                                </p>
                            </div> */}
            {/* </div>
                    </div>
                </div>
            </section> */}
            {/* <section className='base-container'>
                <div className="container">
                    <div className="service-info">
                        <div class="info-wrap">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="300">
                                <a href="#" class="icon-text">
                                    <IoPeopleSharp />
                                </a>

                                <h3>Enhanced Earnings Potential</h3>
                                <p class="paragraph">
                                    <strong>Lower Operating Costs:</strong> Benefit from EVs' low maintenance requirements and fuel-free operation, ensuring higher profitability.
                                </p>
                                <p class="paragraph">
                                    <strong>Optimized Utilization:</strong> Advanced AI tools maximize fleet efficiency, ensuring your vehicles are always in demand.
                                </p>
                            </div>
                            <div class="info-card" data-aos="fade-up" data-aos-delay="400">
                                <a href="#" class="icon-text">
                                    <GoGraph />
                                </a>
                                <h3>Seamless Fleet Management</h3>
                                <p class="paragraph">
                                    <strong>Integrated Technology:</strong> Manage schedules, routes, and energy consumption effortlessly with our smart fleet systems.
                                </p>
                                <p class="paragraph">
                                    <strong>Real-Time Insights:</strong> Stay informed with live data on vehicle performance, battery status, and delivery metrics for better decision-making.
                                </p>
                            </div>
                            <div class="info-card" data-aos="fade-up" data-aos-delay="500">
                                <a href="#" class="icon-text">
                                    <IoMdMail />
                                </a>
                                <h3>Commitment to Sustainability </h3>
                                <p class="paragraph">
                                    <strong>Be a Green Pioneer:</strong> Partner with I-Line to lead the shift toward zero-emission logistics, enhancing your brand’s reputation and environmental impact.
                                </p>
                                <p class="paragraph">
                                    <strong>Supportive Network:</strong> Leverage our ecosystem for long-term success, from leasing to battery management and maintenance support.
                                </p>
                            </div> */}

            {/* <div class="info-card">
                                <a href="#" class="icon-text">
                                    <FaBuffer />
                                </a>
                                <h3>Quality</h3>
                                <p class="paragraph-large dark-gray">
                                    We are committed to deliver outstanding, cutting edge IT
                                    solutions that add real value that goes beyond what is
                                    expected.
                                    <br />
                                </p>
                            </div> */}
            {/* </div>
                        <div className='ServiceBottom text-center py-5'>
                            <p>Our list of services does not end here. We’ll adapt to your particular needs.</p>
                            <a href="javascript:void(0);">Get a Quote for Your Business <FaArrowRight /></a>
                        </div>
                    </div>
                </div>
            </section> */}



            {/* <section className='TestimomnialArea'>
                <div className="container">
                    <div className="section-title">
                        <h2>Testimonials</h2> */}
            {/* <p>With lots of unique blocks, you can easily build a page without<br /> coding. Build your next landing page.</p> */}
            {/* </div> */}
            {/* <div className="row gy-5">
                        {
                            CarouselData?.map((item) => {
                                return (
                                    <div className="col-lg-4 col-md-6">
                                        <div class='item'>
                                            <div className="TestimonialBox">
                                                <h3>{item?.content}</h3>
                                                <aside>
                                                    <figure><img src={item?.imgsrc} alt='img' /></figure>
                                                    <figcaption>
                                                        <h6>{item?.name}</h6>
                                                        <p>{item?.position}</p>
                                                    </figcaption>
                                                </aside>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div> */}
            {/* <OwlCarousel 
                    className="owl-theme"
                    loop
                    margin={10}
                    autoplay={true} 
                    autoplayTimeout={3000}
                    autoplayHoverPause={true} 
                    responsive={{
                      0: {
                        items: 1, 
                      },
                      600: {
                        items: 1, 
                      },
                      1000: {
                        items: 3, 
                      }
                    }}
                    >
                        {
                            CarouselData?.map((item) => {
                                return (
                                    <div class='item'>
                                        <div className="TestimonialBox">
                                            <h3>{item?.content}</h3>
                                            <aside>
                                                <figure><img src={item?.imgsrc} alt='img' /></figure>
                                                <figcaption>
                                                    <h6>{item?.name}</h6>
                                                    <p>{item?.position}</p>
                                                </figcaption>
                                            </aside>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </OwlCarousel>
                </div>
            </section> */}

            <Footer />
        </>
    )
}

export default About
